/** @format */

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { garderOverlayDev } from "./payments/core/garderOverlayDev";
import "./index.css";

/*
 * Signal ResizeObserver bénin — posé ICI, avant le premier rendu.
 *
 * Le poser dans chaque écran arrivait trop tard : `react-error-overlay`
 * s'enregistre au démarrage du bundle, et pour un événement `error` les
 * écouteurs de `window` se déclenchent dans leur ordre d'enregistrement
 * (voir garderOverlayDev.js). Un écran chargé en `lazy` passait donc
 * toujours après lui. Ici, il passe avant — et couvre tout l'ERP, pas
 * seulement les écrans de paiement : n'importe quelle table Ant Design
 * peut émettre ce signal.
 */
garderOverlayDev();

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
